import { defineMetrics } from "../types.js"

export const lifecycleMetrics = defineMetrics([
  {
    id: "products_removed",
    name: "Products Removed",
    description: "Number of Products deleted during the reporting period.",
    logic: "Count deleted Products during the selected period.",
    source: "auditTrail(module='Product', action='Delete Product')",
    domain: "lifecycle",
    srvModule: "lifecycle",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stacked-bar", "stat-tile"],
    coveredByV1: false,
    xlsxRow: 21,
  },
  {
    id: "product_families_removed",
    name: "Product Families Removed",
    description: "Number of Product Families removed during the reporting period.",
    logic: "Count deleted Product Families.",
    source: "auditTrail(module='ProductFamily', action='Delete Product Family')",
    domain: "lifecycle",
    srvModule: "lifecycle",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stacked-bar", "stat-tile"],
    coveredByV1: false,
    xlsxRow: 23,
  },
  {
    id: "product_solutions_removed",
    name: "Product Solutions Removed",
    description: "Number of Product Solutions removed during the reporting period.",
    logic: "Count deleted Product Solutions.",
    source: "auditTrail(module='ProductSolution', action='Delete Product Solution')",
    domain: "lifecycle",
    srvModule: "lifecycle",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stacked-bar", "stat-tile"],
    coveredByV1: false,
    xlsxRow: 25,
  },
  {
    id: "trackings_deleted",
    name: "Trackings Deleted",
    description: "Number of deleted Trackings.",
    logic: "Count deleted Trackings during the reporting period.",
    source: "auditTrail(module='Tracking', action='Delete Tracking')",
    domain: "lifecycle",
    srvModule: "lifecycle",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stacked-bar", "stat-tile"],
    coveredByV1: false,
    xlsxRow: 45,
  },
  {
    id: "watchlist_removals",
    name: "Watchlist Removals",
    description: "Number of items removed from Watchlists.",
    logic: "Count removals during the reporting period. Requires an event log of additions over time",
    source: "auditTrail(module='StandardWatchList'|'GuidanceWatchList'|'LegislationWatchlist', action='Delete <kind> From Watchlist')",
    domain: "lifecycle",
    srvModule: "lifecycle",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stacked-bar", "stat-tile"],
    coveredByV1: false,
    xlsxRow: 76,
  },
])
